/* Il retro della maglia esiste solo dove c'e' un puntatore.
 *
 * Queste immagini arrivano dal server senza src: l'indirizzo sta in data-src e
 * viene montato qui. Su un telefono non viene montato affatto, quindi meta'
 * delle immagini della pagina - venticinque rovesci su cinquanta foto - non
 * viene chiesta alla rete da chi non potrebbe comunque vederla.
 *
 * L'alternativa era lasciarle con src e nasconderle con display:none, contando
 * sul fatto che il browser non scarica un'immagine pigra mai disegnata. E' vero
 * nei browser di oggi, ma e' un'ottimizzazione, non una garanzia, e in prova non
 * sono riuscito a verificarla: un <img> senza src invece non chiede niente, e
 * questo si vede contando le richieste.
 *
 * loading="lazy" resta valido anche quando l'src arriva dopo, quindi i rovesci
 * in fondo alla griglia aspettano comunque il loro turno.
 */
(function () {
  'use strict';

  if (!window.matchMedia || !window.matchMedia('(hover: hover)').matches) return;

  var backs = document.querySelectorAll('.radar-garment__back[data-src]');
  for (var i = 0; i < backs.length; i += 1) {
    var img = backs[i];
    if (img.dataset.srcset) img.srcset = img.dataset.srcset;
    img.src = img.dataset.src;
  }
})();
